import { type SerializedCompStructure } from '@wix/document-services-types'

import { type DatePickerData } from '../types'

export function assertDatePickerData(
  data: NonNullable<SerializedCompStructure['data']>,
): asserts data is DatePickerData {
  const TYPE: DatePickerData['type'] = 'DatePicker'
  if (data.type !== TYPE) {
    throw new Error('Not date-picker data.')
  }
}
